module.exports = __webpack_public_path__ + "static/media/starwars.83ff8ae7.gif";